(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('liveChatService', ['$interval', 'jwtService', 'comapiChatService', 'chatAnalyticsService', 'chatPresenceService', 'apiSpacePicker', 'channelsProvider',
            function ($interval, jwtService, comapiChatService, chatAnalyticsService, chatPresenceService, apiSpacePicker, channelsProvider) {

                // this service generates 3 types of data
                // allow client to decide what they actually want 
                var _requestedStats = {
                    timeline: true,
                    channelSpread: true,
                    team: true
                }

                var _callbacks = [];
                var _interval;

                var _avatars = {};
                var _firstNames = {};
                // snapshot of ALL open conversations when we initialised
                var _conversations = {};

                var _buckets = [{
                    label: '-60 min',
                    timeRange: 1000 * 60 * 60
                }, {
                    label: '-30 min',
                    timeRange: 1000 * 60 * 30
                }, {
                    label: '-20 min',
                    timeRange: 1000 * 60 * 20
                }, {
                    label: '-10 min',
                    timeRange: 1000 * 60 * 10
                }, {
                    label: '-5 min',
                    timeRange: 1000 * 60 * 5
                }, {
                    label: '-1 min',
                    timeRange: 1000 * 60
                }, {
                    label: '-30 sec',
                    timeRange: 1000 * 30
                }, {
                    label: '-20 sec',
                    timeRange: 1000 * 20
                }, {
                    label: '-10 sec',
                    timeRange: 1000 * 10
                }];

                var _conversationEvents = [];

                var _channelSpread = {
                    "sms": {},
                    "fbMessenger": {},
                    "twitterDm": {},
                    "appMessaging": {},
                    "email": {},
                    "whatsApp": {},
                    "rcs": {}
                };

                var _channelIdLookup = {
                    "sms": "SMS",
                    "fbMessenger": "Messenger",
                    "twitterDm": "Twitter",
                    "appMessaging": "App Messaging",
                    "email": "Email",
                    "whatsApp": "WhatsApp",
                    "rcs": "RCS"
                }

                //removing channels that aren't allowed to be displayed
                for (var channelId in channelsProvider) {
                    if (!channelsProvider[channelId].allowed) {
                        delete _channelSpread[channelId];
                        delete _channelIdLookup[channelId];
                    }
                }


                var _presence = {};
                var _teamAgentStatistics = {};
                var _teams;
                var _teamIdLookup = {};
                var _currentTeamId;
                var _currentTeam;


                /**
                 * 
                 * @param {*} profileId 
                 */
                function sanitizeProfileId(profileId) {
                    return profileId.replace("PLATFORMUSER\\", "");
                }

                /**
                 * 
                 * @param {*} event 
                 */
                function _createConversation(event) {
                    return {
                        id: event.conversationId,
                        channelId: event.channelId,
                        teamId: event.teamId,
                        chatStatus: event.chatStatus,
                        participants: {
                            agent: [],
                            participant: []
                        }
                    }
                }

                /**
                 * 
                 * @param {*} conversationId 
                 * @param {*} event 
                 */
                function addParticipant(event) {

                    var conversation = _conversations[event.conversationId];

                    if (!conversation) {
                        conversation = _createConversation(event);
                        _conversations[event.conversationId] = conversation;
                    }

                    var sanitized = sanitizeProfileId(event.profileId);
                    if (conversation.participants[event.role].indexOf(sanitized) === -1) {
                        conversation.participants[event.role].push(sanitized);
                    }
                }

                /**
                 * 
                 * @param {*} conversation
                 */
                function _getAllocatedTo(conversation) {
                    return conversation.participants.agent[0] || conversation.teamId;
                }

                /**
                 * 
                 * @param {*} conversationId 
                 * @param {*} event 
                 */
                function removeParticipant(event) {
                    var conversation = _conversations[event.conversationId];

                    if (!conversation) {
                        conversation = _createConversation(event);
                        _conversations[event.conversationId] = conversation;
                    }

                    var sanitized = sanitizeProfileId(event.profileId);
                    var index = conversation.participants[event.role].indexOf(sanitized);

                    if (index >= 0) {
                        conversation.participants[event.role].splice(index, 1);
                    }
                }

                /**
                 * Given an array of millisecond based, calculate the average and convert to seconds
                 * @param {*} responseTimes 
                 */
                function _getAvgAgentResponseTime(responseTimes) {
                    if (responseTimes && responseTimes.length) {
                        var sum = 0;

                        responseTimes.forEach(function (rt) {
                            sum += rt;
                        });

                        return (sum / responseTimes.length) / 1000;

                    } else {
                        return 0;
                    }
                }

                /**
                 * Create an object with properties for all teams
                 */
                function constructCountObject() {
                    var obj = {};

                    _teams.forEach(function (team) {
                        obj[team.id] = 0;
                    });

                    return obj;
                }

                /**
                 * Get stats for a single team
                 * @param {*} teamId 
                 */
                function getTeamStats(teamId) {

                    var teamStats = [];

                    var allNewSum = 0;
                    var allOpenSum = 0;

                    var allAvgResponse = 0;
                    var allAvgResponseCount = 0;

                    for (var agentName in _teamAgentStatistics[teamId]) {

                        var agentStats = _teamAgentStatistics[teamId][agentName];

                        // seed the data 

                        var newSum = 0;
                        var openSum = 0;

                        for (var id in agentStats.chats) {
                            var chat = agentStats.chats[id];

                            if (chat.status === "new") {
                                newSum++;
                                openSum++;
                            } else if (chat.status === "replied") {
                                openSum++;
                            }
                        }

                        allNewSum += newSum;
                        allOpenSum += openSum;

                        var avgResponse = _getAvgAgentResponseTime(agentStats.responseTimes);

                        if (avgResponse) {
                            allAvgResponse += avgResponse;
                            allAvgResponseCount++;
                        }

                        teamStats.push({
                            team: _teamIdLookup[teamId],
                            agent: _firstNames[agentName] || "Unassigned",
                            status: _presence[agentName],
                            avatar: _avatars[agentName],
                            new: newSum,
                            open: openSum,
                            avgResponse: avgResponse ? avgResponse.toFixed(2) : 0
                        });
                    }

                    teamStats.push({
                        team: "Total",
                        new: allNewSum,
                        open: allOpenSum,
                        avgResponse: allAvgResponse ? (allAvgResponse / allAvgResponseCount).toFixed(2) : 0
                    });

                    return teamStats;
                }

                /**
                 * Get stats for all teams
                 */
                function getTeamsStats() {

                    var teamStats = [];

                    for (var teamId in _teamAgentStatistics) {

                        var newSum = 0;
                        var openSum = 0;

                        var avgResponseSum = 0;
                        var avgResponseCount = 0;

                        for (var agentName in _teamAgentStatistics[teamId]) {

                            var agentStats = _teamAgentStatistics[teamId][agentName];

                            for (var id in agentStats.chats) {
                                var chat = agentStats.chats[id];

                                if (chat.status === "new") {
                                    newSum++;
                                    openSum++;
                                } else if (chat.status === "replied") {
                                    openSum++;
                                }
                            }

                            agentStats.responseTimes.forEach(function (rt) {
                                avgResponseSum += rt;
                                avgResponseCount++;
                            });
                        }

                        teamStats.push({
                            team: _teamIdLookup[teamId],
                            new: newSum,
                            open: openSum,
                            avgResponse: avgResponseSum ? ((avgResponseSum / avgResponseCount) / 1000).toFixed(2) : 0
                        });
                    }

                    return teamStats;
                }

                /**
                 * 
                 */
                function _tick() {
                    var now = new Date().valueOf();

                    var timelineData = [];
                    for (var i = 0; i < _buckets.length; i++) {
                        timelineData.push(0);
                    }

                    if (_requestedStats.timeline) {
                        var splitIndex = -1;
                        for (var i = _conversationEvents.length - 1; i >= 0 && splitIndex === -1; i--) {
                            var event = _conversationEvents[i];

                            if (event.teamId === _currentTeamId) {
                                var dt = now - event.timeStamp;

                                // which bucket to put the event in ?
                                // TODO: can cache position to speed this up as all events are in date order ...
                                var found = false;
                                for (var j = _buckets.length - 1; j >= 0 && !found; j--) {
                                    var bucket = _buckets[j];
                                    if (dt <= bucket.timeRange) {
                                        found = true;
                                        timelineData[j] += event.count;
                                    }
                                }
                                if (!found) {
                                    splitIndex = i;
                                    // event > 30 mins old ...
                                }
                            }
                        }
                        // anything left of this is now older than 1/2 an hour (or the largest bucket)
                        // we can bin all of these off
                        if (splitIndex >= 0) {
                            _conversationEvents.splice(0, splitIndex + 1);
                        }
                    }

                    var labelColors = {
                        sms: "#12f990",
                        fbMessenger: "#01b8ff",
                        twitterDm: "#1da1f2",
                        appMessaging: "#865cd6",
                        email: "#fabb49",
                        whatsApp: "#25D366",
                        rcs: "#333333"
                    }

                    var channelSpreadInfo = {
                        data: [],
                        labels: [],
                        colors: []
                    }


                    if (_requestedStats.channelSpread && _currentTeam) {
                        for (var channelId in _currentTeam.channels) {
                            channelSpreadInfo.data.push(_channelSpread[channelId][_currentTeamId]);
                            channelSpreadInfo.labels.push(_channelIdLookup[channelId]);
                            channelSpreadInfo.colors.push(labelColors[channelId])
                        }
                    }

                    var teamStats = [];

                    if (_requestedStats.team) {
                        if (_currentTeamId) {
                            teamStats = getTeamStats(_currentTeamId)
                        } else {
                            teamStats = getTeamsStats()
                        }

                    }

                    var data = {
                        timeline: timelineData,
                        channelSpread: channelSpreadInfo,
                        team: teamStats
                    }

                    _callbacks.forEach(function (callback) {
                        callback(data);
                    });
                }



                /**
                 * Listen for presence events an update our data as necessary.
                 * @param {*} event 
                 */
                function _webSocketEventHandler(event) {

                    switch (event.name) {
                        case "presence.away":
                        case "presence.offline":
                        case "presence.available":
                            var member = event.payload.profileId.replace("PLATFORMUSER\\", "");
                            _presence[member] = event.payload.status;
                            break;
                        /**
                         * status change events
                         */
                        case "chat.status":
                            _statusUpdateEventHandler(event);
                            break;
                        /**
                         * chat closed event
                         */
                        case "chat.closed":
                            _closeConversationEventHandler(event);
                            break;

                        case "chat.teamChanged":
                            _teamChangedEventHandler(event);
                            break;
                    }
                }

                var webSocketEventHandler = _webSocketEventHandler.bind(this);

                /**
                 * Listen for participant removed events an update our data as necessary.
                 * @param {*} event 
                 */
                function _participantRemovedEventHandler(event) {

                    removeParticipant(event);

                    // find this conversation                                        
                    var agentId = event.profileId.replace("PLATFORMUSER\\", "");
                    var teamId = event.teamId

                    for (var conversationId in _teamAgentStatistics[teamId][agentId].chats) {

                        if (conversationId === event.conversationId) {
                            delete _teamAgentStatistics[teamId][agentId].chats[event.conversationId];
                            break;
                        }
                    }

                    var conversation = _conversations[event.conversationId];

                    _teamAgentStatistics[teamId][teamId].chats[event.conversationId] = {
                        status: conversation.chatStatus
                    }
                }

                var participantRemovedEventHandler = _participantRemovedEventHandler.bind(this);

                /**
                 * 
                 * @param {*} event 
                 */
                function _participantAddedEventHandler(event) {

                    var allocatedTo;
                    // who is this currently allocated to ?
                    var conversation = _conversations[event.conversationId];

                    var isNew = true;;

                    if (conversation) {
                        isNew = false;
                        allocatedTo = _getAllocatedTo(conversation);

                        // need to un-allocate existing participant from _teamAgentStatistics (may have been just allocated to the team)
                        delete _teamAgentStatistics[event.teamId][allocatedTo].chats[event.conversationId];
                    }

                    addParticipant(event);

                    var conversation = _conversations[event.conversationId];
                    allocatedTo = _getAllocatedTo(conversation);

                    _teamAgentStatistics[event.teamId][allocatedTo].chats[event.conversationId] = {
                        status: conversation.chatStatus,
                        timestamp: conversation.chatStatus === "new" ? new Date().valueOf() : undefined
                    }

                    // If new then we need to trigger some stats                    

                    if (_teamIdLookup[allocatedTo] && isNew) {

                        _channelSpread[conversation.channelId][event.teamId]++;

                        // just churn onto end of array 
                        _conversationEvents.push({
                            teamId: event.teamId,
                            count: 1,
                            timeStamp: new Date().valueOf()
                        });

                    }
                }

                var participantAddedEventHandler = _participantAddedEventHandler.bind(this);

                /**
                 * NOTE: this event has chatId instead of conversationId
                 * TODO: sort that out!!!!
                 * @param {*} event 
                 */
                function _statusUpdateEventHandler(event) {

                    var conversation = _conversations[event.chatId];

                    if (conversation) {

                        conversation.chatStatus = event.payload.status;

                        var teamId = conversation.teamId;

                        var allocatedTo = _getAllocatedTo(conversation);

                        if (event.payload.status === "new") {

                            _channelSpread[conversation.channelId][teamId]++;

                            _teamAgentStatistics[teamId][allocatedTo].chats[event.chatId] = {
                                status: "new",
                                timestamp: new Date().valueOf()
                            }

                            // just churn onto end of array 
                            _conversationEvents.push({
                                teamId: teamId,
                                count: 1,
                                timeStamp: new Date().valueOf()
                            });

                        } else {

                            var chat = _teamAgentStatistics[teamId][allocatedTo].chats[event.chatId];
                            if (chat && chat.status === "new") {

                                // may have already been new so we dont have the timestamp
                                if (chat.timestamp) {
                                    // agent has replied, calculate the response time ...
                                    var now = new Date().valueOf();
                                    var responseTimeMs = now - chat.timestamp;
                                    chat.timestamp = undefined;
                                    _teamAgentStatistics[teamId][allocatedTo].responseTimes.push(responseTimeMs);
                                }
                                chat.status = "replied";

                            } else {

                                _teamAgentStatistics[teamId][allocatedTo].chats[event.chatId] = {
                                    status: "replied"
                                }
                            }
                        }
                    }
                }

                /**
                 * 
                 * @param {*} event 
                 */
                function _closeConversationEventHandler(event) {

                    var conversation = _conversations[event.chatId];

                    var allocatedTo = _getAllocatedTo(conversation);

                    // delete from _teamAgentStatistics 
                    delete _teamAgentStatistics[conversation.teamId][allocatedTo].chats[conversation.id];

                    // _channelSpread
                    if (_channelSpread[conversation.channelId][conversation.teamId] > 0) {
                        _channelSpread[conversation.channelId][conversation.teamId]--;
                    }

                    // delete from _conversations
                    delete _conversations[event.chatId];
                }

                /**
                 * 
                 * @param {*} event 
                 */
                function _teamChangedEventHandler(event) {

                    var conversation = _conversations[event.chatId];

                    if (conversation) {

                        var allocatedTo = _getAllocatedTo(conversation);
                        delete _teamAgentStatistics[conversation.teamId][allocatedTo].chats[conversation.id];

                        // update with new teamId
                        conversation.teamId = event.payload.teamId;
                        allocatedTo = _getAllocatedTo(conversation);

                        // add into new stat 
                        _teamAgentStatistics[conversation.teamId][allocatedTo].chats[conversation.id] = {
                            status: conversation.chatStatus,
                            timestamp: conversation.chatStatus === "new" ? new Date().valueOf() : undefined
                        }
                    }

                }


                function _createAgentStats() {
                    return {
                        chats: {},
                        responseTimes: [],
                    }
                }

                /**
                 * 
                 */
                function _createTeamAgentStatistics(teams) {

                    var tas = {};

                    teams.forEach(function (team) {

                        tas[team.id] = {
                        };

                        // this one is for unallocated chats
                        tas[team.id][team.id] = _createAgentStats();

                        if (team.members) {
                            team.members.forEach(function (member) {
                                tas[team.id][member.username] = _createAgentStats();
                            });
                        }
                    });

                    return tas;
                }

                var fac = {
                    /**
                     * Initialise buckets and optionally seed with data
                     * @param {string[]} teams list of teams
                     * @param {Object} seedData - no idea yet
                     */
                    initialise: function (teams, currentTeamId, users, requestedStats) {

                        _teams = teams;

                        _teamAgentStatistics = _createTeamAgentStatistics(teams);

                        for (var propertyName in _channelSpread) {
                            _channelSpread[propertyName] = constructCountObject();
                        }

                        var pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;

                        return chatAnalyticsService.getLastHourData(pickedApiSpaceId)
                            .then(function (data) {
                                // get `all` open conversations ...
                                data.forEach(function (item) {

                                    if (item.transitionsToNew) {
                                        // just churn onto end of array 
                                        _conversationEvents.push({
                                            teamId: item.teamId,
                                            count: item.transitionsToNew,
                                            timeStamp: new Date(item.dateUtc).valueOf()
                                        });
                                    }
                                });

                                return comapiChatService.chatClient.foundation.services.appMessaging.getConversations("scope=all&includeClosed=false");
                            })
                            .then(function (conversations) {

                                // need to be able to reference these by conversationId efficiently so create a lookup
                                conversations.forEach(function (conversation) {

                                    var c = {
                                        channelId: conversation.channelId,
                                        chatStatus: conversation.status,
                                        id: conversation.id,
                                        participants: {
                                            agent: [],
                                            participant: []
                                        },
                                        teamId: conversation.teamId,
                                    }

                                    _channelSpread[conversation.channelId][conversation.teamId]++;

                                    conversation.participants.forEach(function (participant) {
                                        c.participants[participant.role].push(sanitizeProfileId(participant.id));
                                    });

                                    // seed _teamAgentStatistics
                                    var allocatedTo = _getAllocatedTo(c);

                                    if (_teamAgentStatistics[conversation.teamId][allocatedTo]) {
                                        _teamAgentStatistics[conversation.teamId][allocatedTo].chats[conversation.id] = {
                                            status: conversation.status,
                                            // won't add a timestamp as we can't get this info
                                            // timestamp: new Date().valueOf()
                                        }

                                        _conversations[conversation.id] = c;
                                    }

                                });

                                _requestedStats = requestedStats || {
                                    timeline: true,
                                    channelSpread: true,
                                    team: true
                                };

                                // make a teamId => name lookup
                                teams.forEach(function (team) {
                                    _teamIdLookup[team.id] = team.name;
                                })

                                users.forEach(function (user) {
                                    _avatars[user.userName] = user.avatarUrl || "assets/img/avatar.svg";
                                    _firstNames[user.userName] = user.firstName || user.userName;

                                });

                                comapiChatService.addEventListener("webSocketEvent", webSocketEventHandler);
                                comapiChatService.addEventListener("participantRemoved", participantRemovedEventHandler);
                                comapiChatService.addEventListener("participantAdded", participantAddedEventHandler);

                                if (currentTeamId) {
                                    fac.setTeam(currentTeamId);
                                }

                                _interval = $interval(function () {
                                    _tick();
                                }, 1000);

                                return true;

                            })
                            .catch(function (error) {
                                return false;
                            });
                    },
                    /**
                     * Uninitialise (stop the interval)
                     */
                    uninitialise: function () {
                        comapiChatService.removeEventListener("webSocketEvent", webSocketEventHandler);
                        comapiChatService.removeEventListener("participantRemoved", participantRemovedEventHandler);
                        comapiChatService.removeEventListener("participantAdded", participantAddedEventHandler);
                        $interval.cancel(_interval);
                        _interval = undefined;
                        _currentTeamId = undefined;
                        _currentTeam = undefined;
                        _teamIdLookup = {};
                        _callbacks = [];
                        _conversations = {};
                        _channelSpread = {
                            "sms": {},
                            "fbMessenger": {},
                            "twitterDm": {},
                            "appMessaging": {},
                            "email": {},
                            "whatsApp": {},
                            "rcs": {}
                        }

                        //removing channels that aren't allowed to be displayed
                        for (var channelId in channelsProvider) {
                            if (!channelsProvider[channelId].allowed) {
                                delete _channelSpread[channelId];
                            }
                        }
                    },
                    /**
                     * Has the effect of applying a filter to the data that is getting fired from the callbacks
                     */
                    setTeam: function (teamId) {
                        _currentTeamId = teamId;

                        _currentTeam = _teams.find(function (t) {
                            return t.id === teamId;
                        })

                        if (_currentTeam.members) {

                            // get initial agent presence
                            var profileIds = [];

                            _currentTeam.members.forEach(function (member) {
                                profileIds.push("PLATFORMUSER\\" + member.username);
                            });

                            var pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;

                            chatPresenceService.getPresences(pickedApiSpaceId, profileIds)
                                .then(function (result) {

                                    result.forEach(function (user) {
                                        var member = user.profileId.replace("PLATFORMUSER\\", "");

                                        // we want to get the presence of the logged in user from comapiChatService if it is there
                                        // as it will be more accurate 

                                        if (member === jwtService.payload.sub) {
                                            // favour what the comapiChatService has if it is set ...
                                            _presence[member] = comapiChatService.lastStatus || user.status;
                                        } else {
                                            _presence[member] = user.status;
                                        }

                                    });
                                });
                        }
                    },
                    /**
                     * Add Callback 
                     */
                    addEventListener: function (callback) {
                        if (_callbacks.indexOf(callback) === -1) {
                            _callbacks.push(callback);
                        }
                    },
                    /**
                     * Remove Callback
                     */
                    removeEventListener: function (callback) {

                        var index = _callbacks.indexOf(callback);

                        if (index !== -1) {
                            _callbacks.splice(index, 1);
                        }
                    },


                };

                return fac;

            }
        ]);
})(window.angular);